<template>
  <div v-if="playlistData.maps" class="maps">
    <h2>Maps & layouts</h2>
    <figure v-for="(map, index) in playlistData.maps" :key="index" @click="openModal(map)">
      <div class="image-container rounded bordered">
        <img :src="map.image" :title="map.name" />
        <div class="zoom rounded"><i class="material-icons">zoom_in</i></div>
      </div>
      <figcaption>{{map.name}}</figcaption>
    </figure>
  </div>
</template>

<script>
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
export default {
  name: "Maps",
  mixins: [scenarioMixin],
  computed: {},
  methods: {
    openModal (map) {
      this.$store.dispatch('modalModule/setActive', {...map, type: "image"} )
    }
  }
}
</script>

<style scoped lang="scss">

h2 {
  color: var(--primary);
  width: 100%;
  padding: 0 20px;
}
.maps {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -20px;
  padding: 25px;
  background: transparent !important;
}

.image-container {
  position: relative;
  margin-bottom: 6px;
  transition: 0.25s;

  &::after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.zoom {
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 5;
  bottom: 0;
  right: 0;
  background-color: var(--primary);
  color: #fff;
  padding: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  transition: 0.25s;
}
figure {
  margin: 20px;
  // flex: 0 1;
  flex: 1;
  min-width: 170px;
  max-width: 330px;

  &:hover {
    cursor: pointer;
    .zoom {
      background-color: #e1651d;
    }
    .image-container {
      border-color: #e1651d;
    }
  }
  
  img {
    max-width: 100%;
    width: 100%;
  }

 figcaption {
   font-size: 14px;
   color: var(--primary);
 }
}
</style>